<template>
  <ImgComponentContent
    :src="src"
    :fallback="fallback"
    :avatar="avatar"
    :key="`${src}${fallback}${avatar}`"
  />
</template>

<script>
import { defineComponent } from 'vue'
import ImgComponentContent from './ImgComponentContent.vue'

export default defineComponent({
  name: 'ImgComponent',
  components: { ImgComponentContent },
  props: {
    src: { type: String, default: '' },
    fallback: { type: String, default: '' },
    avatar: { type: Boolean, default: false },
  },
  data() {
    return {}
  },
  methods: {},
  computed: {},
  watch: {},
})
</script>
